import React from "react";
import { useRouter } from "@/router/Router";
import { useCart } from "@/state/CartContext";
import { useI18n } from "@/i18n";

function HomeIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M4 11.5 12 4l8 7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 10v9h12v-9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
function CatalogIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
      <rect x="13" y="4" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
      <rect x="4" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
      <rect x="13" y="13" width="7" height="7" rx="1.5" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}
function CartIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path d="M3 4h2l1.6 10.6a2 2 0 0 0 2 1.7h8a2 2 0 0 0 2-1.7L20 8H6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="9.5" cy="20" r="1.4" fill="currentColor" />
      <circle cx="16.5" cy="20" r="1.4" fill="currentColor" />
    </svg>
  );
}
function ProfileIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="3.4" stroke="currentColor" strokeWidth="1.8" />
      <path d="M5 20c1.2-4 4-5.6 7-5.6s5.8 1.6 7 5.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export function BottomNav() {
  const { route, navigate } = useRouter();
  const { totalItems } = useCart();
  const { t } = useI18n();

  const items: Array<{ key: string; label: string; icon: React.ReactNode; active: boolean; onClick: () => void; badge?: number }> = [
    { key: "home", label: t("nav.home"), icon: <HomeIcon />, active: route.name === "home", onClick: () => navigate({ name: "home" }) },
    { key: "catalog", label: t("nav.catalog"), icon: <CatalogIcon />, active: route.name === "catalog", onClick: () => navigate({ name: "catalog" }) },
    { key: "cart", label: t("nav.cart"), icon: <CartIcon />, active: route.name === "cart", onClick: () => navigate({ name: "cart" }), badge: totalItems || undefined },
    { key: "profile", label: t("nav.profile"), icon: <ProfileIcon />, active: route.name === "profile" || route.name === "orders" || route.name === "orderDetail" || route.name === "b2b", onClick: () => navigate({ name: "profile" }) },
  ];

  return (
    <nav className="bottom-nav">
      {items.map((item) => (
        <button key={item.key} className="bottom-nav__item" data-cart-target={item.key === "cart" ? "" : undefined} data-active={item.active} onClick={item.onClick}>
          {item.icon}
          {item.label}
          {!!item.badge && <span className="bottom-nav__badge">{item.badge}</span>}
        </button>
      ))}
    </nav>
  );
}
